import { SyntheticEvent } from 'react'
import Formatter, {
  cnpjMask,
  cepMask,
  normalizeCnpj,
  phoneMask,
} from '../utils/formatters'

export const formatOnlyNumbers = (e: SyntheticEvent): void => {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(Formatter.somenteNumeros(), '')
}

export const formatCnpjMask = (e: SyntheticEvent): void => {
  const input = e.target as HTMLInputElement
  input.value = cnpjMask(normalizeCnpj(input.value))
}

export const formatCep = (e: SyntheticEvent): void => {
  const input = e.target as HTMLInputElement
  formatOnlyNumbers(e)
  input.value = cepMask(input.value)
}

export const formatTelefoneMask = (e: SyntheticEvent): void => {
  const input = e.target as HTMLInputElement
  formatOnlyNumbers(e)
  input.value = phoneMask(input.value)
}
